__turbopack_context__.v({
  "faq-accordion": "FaqAccordion-module-scss-module__DzoOZa__faq-accordion",
  "faq-accordion-wrapper": "FaqAccordion-module-scss-module__DzoOZa__faq-accordion-wrapper",
  "faq-accordion__body": "FaqAccordion-module-scss-module__DzoOZa__faq-accordion__body",
  "faq-accordion__header": "FaqAccordion-module-scss-module__DzoOZa__faq-accordion__header",
  "faq-accordion__heading": "FaqAccordion-module-scss-module__DzoOZa__faq-accordion__heading",
});
